import { Component, OnInit } from '@angular/core';
import { Job } from '@model/entities/job';
import { JobService } from '@service/job.service';
import { Title } from '@angular/platform-browser';
import { ViewCountService } from '@service/view-count.service';
import { PreflightSearchService } from '@service/preflight-search/preflight-search.service';
import { EntityDetailComponent } from '@component/entity-detail-component';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { TypeService } from '@service/type.service';
import { SentryService } from '@service/sentry.service';
import { StateService } from '@service/state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ScrollService } from '@service/scroll.service';
import { CommentService } from '@service/comment/comment.service';

@Component({
  selector: 'app-job-detail',
  templateUrl: './job-detail.component.html',
  styleUrls: ['./job-detail.component.scss'],
})
export class JobDetailComponent extends EntityDetailComponent implements OnInit {
  protected entityTypeIdentifier: EntityTypeIdentifier = 'job';

  public mostViewed: Array<Job>;
  public otherJobs: Array<Job> = null;

  public job: Job;

  public preflightValues: string[];

  constructor(
    private jobService: JobService,
    private viewCountService: ViewCountService,
    private preflightSearchService: PreflightSearchService,
    private title: Title,
    protected entityTypeConfigService: EntityTypeConfigService,
    private typeService: TypeService,
    private sentryService: SentryService,
    public StateService: StateService,
    public ActivatedRoute: ActivatedRoute,
    public Router: Router,
    public ScrollService: ScrollService,
    public CommentService: CommentService,
  ) {
    super(entityTypeConfigService, StateService, Router, ScrollService, CommentService, ActivatedRoute);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getEntity(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loading = true;
      this.jobService
        .getById(id)
        .then((response) => {
          // if it returns a number (id a of a newer version) its a redirect to a newer version of the entity
          if (this.typeService.isNumber(response)) {
            this.jobService
              .getById(<number>response)
              .then((job: Job) => {
                this.StateService.goto('/job/detail/' + id + '/' + job.title);
              })
              .catch((err) => {
                this.sentryService.silentCaptureException(err);
              });

            resolve();
            return;
          }

          // from here on its sure no redirect
          this.job = <Job>response;
          resolve();

          // set page title
          this.title.setTitle(this.job.title + ' | Zimmerer-Treffpunkt');

          this.viewCountService.addView(this.job);

          // get other jobs in same category
          this.jobService.getOtherJobsInCategory(this.job.id, this.job.category.id).then((otherJobs) => {
            this.otherJobs = otherJobs;
          });
        })
        .catch(() => {
          this.doesNotExist = true;
        })
        .finally(() => {
          this.loading = false;
        });

      this.jobService.getMostViewed().then((mostViewed) => {
        this.mostViewed = mostViewed;
      });
    });
  }

  public onPreflightSearch(query: string) {
    if (query.length < 3) return;

    this.preflightSearchService.doPreflightSearch({ tags: 'JOB', search_string: query }).then((preflightValues) => {
      this.preflightValues = preflightValues;
    });
  }
}
